import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-1 rounded-md" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 text-red-600 text-sm"
}
const _hoisted_3 = {
  key: 1,
  class: "text-gray-800 text-center py-4"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "ml-auto transform -translate-y-px mr-4" }

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import SignupMainContainer from '@/components/signup/SignupMainContainer.vue'
import api from '@/store/api'


export default {
  __name: 'ConvertToNewEmail',
  props: {
  mode: {
    type: String,
    default: 'suggest',
    validator: v => ['suggest', 'force'].includes(v)
  },
  /** When true, render as page content without fixed overlay */
  standalone: {
    type: Boolean,
    default: false
  },
  /** When set, dismiss (Not right now / back) navigates to this path instead of emitting */
  dismissToPath: {
    type: String,
    default: ''
  }
},
  emits: ['dismiss'],
  setup(__props, { emit: __emit }) {

const router = useRouter()

const props = __props

const emit = __emit

const step = ref('set-admin')
const email = ref('')
const loading = ref(false)
const errorMessage = ref('')

const pillTitle = computed(() => {
  return step.value === 'set-admin' ? 'Set Account Admin' : 'Confirm Your Email'
})

const isValidEmail = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return email.value && emailRegex.test(email.value)
})

const handleDismiss = () => {
  if (props.dismissToPath) {
    router.push(props.dismissToPath)
  } else {
    console.log('ConvertToNewEmail: User clicked "Not right now..."')
    emit('dismiss')
  }
}

const handleNext = async () => {
  if (!isValidEmail.value) {
    errorMessage.value = 'Please enter a valid email address'
    return
  }

  loading.value = true
  errorMessage.value = ''

  try {
    const response = await api.call('POST', 'system_users/request_convert_password_reset', { email: email.value })
    if (response.errors) {
      errorMessage.value = response.errors.join(', ')
    } else {
      step.value = 'confirm-email'
    }
  } catch (error) {
    console.error('ConvertToNewEmail: Error requesting password reset:', error)
    errorMessage.value = 'An error occurred. Please try again.'
  } finally {
    loading.value = false
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'fixed inset-0 z-50': !__props.standalone })
  }, [
    _createVNode(SignupMainContainer, {
      title: pillTitle.value,
      "image-position": "left",
      "max-width": "md:max-w-xl",
      "back-click-handler": __props.mode === 'suggest' && step.value === 'set-admin' ? handleDismiss : null,
      "hide-navigation": __props.mode === 'suggest' && step.value === 'confirm-email',
      "hide-back-button": __props.mode === 'force'
    }, {
      body: _withCtx(() => [
        (step.value === 'set-admin')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-gray-800 text-xl tracking-tighter" }, " Setup your first account admin for Bottle.com's new authentication process. ", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-gray-700 space-y-2" }, [
                _createElementVNode("p", null, "Once you do this a few things will happen:"),
                _createElementVNode("ul", { class: "space-y-1 ml-1" }, [
                  _createElementVNode("li", null, "- You will receive an email to confirm your email address."),
                  _createElementVNode("li", null, "- Click the link in the email to set your password."),
                  _createElementVNode("li", null, " - Once complete your account will be converted to this new authentication and your old login will no longer work. ")
                ]),
                _createElementVNode("p", { class: "pt-2" }, [
                  _createTextVNode(" Need Help? Email "),
                  _createElementVNode("a", {
                    href: "mailto:team@bottle.com",
                    class: "underline font-medium"
                  }, "team@bottle.com")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((email).value = $event)),
                  type: "email",
                  placeholder: "michael@bluthcompany.com",
                  class: "placeholder-gray-400 block px-3 py-3.5 rounded-lg w-full focus:border-gray-800 border-2 border-gray-200 focus:ring-0 appearance-none transition duration-150 ease-in-out text-sm leading-5 focus:outline-none font-semibold tracking-wide",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys($event => (isValidEmail.value && handleNext()), ["enter"]))
                }, null, 544), [
                  [_vModelText, email.value]
                ])
              ]),
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, " Check your inbox to confirm your email. Follow the link in the email to set your password. "))
      ]),
      footer: _withCtx(() => [
        (step.value === 'set-admin')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.mode !== 'force')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "text-sm inline-flex items-center justify-center border-gray-800 border-2 text-md hover:shadow-lg transition-all rounded-lg px-3 md:px-8 py-3.5 leading-tight bg-white text-gray-800 tracking-tighter",
                    onClick: handleDismiss
                  }, " Not right now... "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                disabled: loading.value || !isValidEmail.value,
                class: _normalizeClass([
              loading.value || !isValidEmail.value
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-yellow-200 text-gray-800 hover:shadow-lg',
              'ml-2 inline-flex items-center border-gray-800 border-2 font-bold text-md transition-all rounded-full px-6 py-3.5 leading-tight'
            ]),
                onClick: handleNext
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(loading.value ? 'Sending...' : 'Next'), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mr-auto" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "34",
                    height: "13",
                    viewBox: "0 0 34 13"
                  }, [
                    _createElementVNode("path", {
                      d: "M3.11,6.82A20,20,0,0,1,1.2,6a.46.46,0,0,0-.67.15A2.32,2.32,0,0,0,0,7.25C0,7.64,0,7.84.3,8c.59.25,1.18.52,1.78.72",
                      transform: "translate(0 0)"
                    }),
                    _createElementVNode("path", {
                      d: "M1.83,8.58A23.56,23.56,0,0,0,7.36,10a36.41,36.41,0,0,0,8.79,0A53.55,53.55,0,0,0,29.69,6.72l.19-.07,0,0c-.33.4-.65.8-1,1.19-.72.87-1.45,1.73-2.16,2.61a1.75,1.75,0,0,0,0,2.28.68.68,0,0,0,.52.22.73.73,0,0,0,.5-.26c.67-.78,1.33-1.58,2-2.39l3.65-4.41A2.13,2.13,0,0,0,34,4.5,1.24,1.24,0,0,0,33.91,4a.87.87,0,0,0-.28-.36,1.55,1.55,0,0,0-.32-.2L26.59.11c-.65-.31-1.25.05-1.54.92a1.22,1.22,0,0,0,.4,1.5c.95.49,1.91,1,2.86,1.42l1.78.89-.19.08A55.6,55.6,0,0,1,17.44,8a36.08,36.08,0,0,1-8.87.12A21.78,21.78,0,0,1,2.82,6.7c-.3-.12-.73-.1-1-.25",
                      fill: "#000000",
                      transform: "translate(0 0)"
                    })
                  ])
                ], -1))
              ], 10, _hoisted_4)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "back-click-handler", "hide-navigation", "hide-back-button"])
  ], 2))
}
}

}